import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight'
import { Button } from 'antd'

import { IEvaluationResume } from 'models/evaluation.model'
import { evaluationsService } from 'api/courses/evaluations'
import { EvaluationResponseStatus } from 'enum/evaluationResponseStatus.enum'
import { useCourse } from 'contexts'
import SimpleResume from '../../components/evaluation-resume'
import { Buttons } from '../../components/evaluation-resume/styled'

interface IProps {
  evaluation: IEvaluationResume
  showEvaluation: () => void
}

const WithoutStarting = ({ evaluation, showEvaluation }: IProps) => {
  const { t } = useTranslation()
  const translationPrefix = 'lessons.contentBlocks.evaluationBlock.detail'
  const [loading, setLoading] = useState(false)
  const { canAnswer } = useCourse()

  const handleStart = async () => {
    setLoading(true)
    try {
      const evaluationResponse = evaluation.evaluationResponse
      const hasResponse = evaluationResponse?.id
      if (!hasResponse)
        await evaluationsService.createEvaluationResponse(evaluation.id)
      else if (
        evaluationResponse.status === EvaluationResponseStatus.notStarted
      )
        await evaluationsService.startEvaluation(evaluationResponse.id)
      showEvaluation()
    } finally {
      setLoading(false)
    }
  }

  const isDisabled = loading || !canAnswer

  return (
    <>
      <SimpleResume evaluation={evaluation} />
      <Buttons>
        <Button disabled={isDisabled} onClick={handleStart}>
          {t(`${translationPrefix}.buttons.start`)}
          <FontAwesomeIcon icon={faArrowRight} />
        </Button>
      </Buttons>
    </>
  )
}

export default WithoutStarting
